import { useEffect, useRef, useState } from 'react'

export function useListScrollRender(total: number) {
  const listInnerRef = useRef<any>()
  const [end, setEnd] = useState<number>(50)

  useEffect(() => {
    const onScroll = () => {
      if (listInnerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current
        const isNearBottom = Math.abs(scrollHeight - (scrollTop + clientHeight)) <= clientHeight / 2
        if (isNearBottom) {
          if (end < total) {
            setEnd(end + 50)
          }
        }
      }
    }
    const listInnerElement = listInnerRef.current as any
    if (listInnerElement) {
      listInnerElement.addEventListener('scroll', onScroll)
      // Clean-up
      return () => {
        listInnerElement.removeEventListener('scroll', onScroll)
      }
    }
  }, [end, total])

  return {
    ref: listInnerRef,
    end,
    setEnd
  }
}
